import { CoffeeOutlined, EyeOutlined, SmileOutlined } from '@ant-design/icons'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { ColumnLayout } from '@/components'
import { SectionType, useSectionUnReadUpdateSubscription } from '@/generated/graphql'
import { SearchHeader } from '@/modules/app'
import { PostsContainer } from '@/modules/post/posts.container'

import { appState } from '../app/app.state'

export const NewAgoranSectionContainer = () => {
  const { t } = useTranslation()

  useSectionUnReadUpdateSubscription({
    variables: {
      sectionId: SectionType.NewAgoran,
    },
  })

  React.useEffect(() => {
    appState({ ...appState(), showSearchHeader: true })
    return () => {
      appState({ ...appState(), showSearchHeader: false })
    }
  }, [])

  const header = (
    <SearchHeader title={t('section.NewAgoran.title')} avatar={<SmileOutlined style={{ fontSize: 24 }} />} />
  )
  const middle = <PostsContainer sectionId={SectionType.NewAgoran} />

  return <ColumnLayout header={header} middle={middle} />
}

export const EntertainSectionContainer = () => {
  const { t } = useTranslation()

  useSectionUnReadUpdateSubscription({
    variables: {
      sectionId: SectionType.Entertainment,
    },
  })
  React.useEffect(() => {
    appState({ ...appState(), showSearchHeader: true })
    return () => {
      appState({ ...appState(), showSearchHeader: false })
    }
  }, [])

  const header = (
    <SearchHeader title={t('section.Entertainment.title')} avatar={<CoffeeOutlined style={{ fontSize: 24 }} />} />
  )

  const middle = <PostsContainer sectionId={SectionType.Entertainment} />

  return <ColumnLayout header={header} middle={middle} />
}

export const OthersSectionContainer = () => {
  const { t } = useTranslation()

  useSectionUnReadUpdateSubscription({
    variables: {
      sectionId: SectionType.Synthesis,
    },
  })
  React.useEffect(() => {
    appState({ ...appState(), showSearchHeader: true })
    return () => {
      appState({ ...appState(), showSearchHeader: false })
    }
  }, [])

  const header = <SearchHeader title={t('section.Synthesis.title')} avatar={<EyeOutlined style={{ fontSize: 24 }} />} />

  const middle = <PostsContainer sectionId={SectionType.Synthesis} />

  return <ColumnLayout header={header} middle={middle} />
}
